import Component from 'flarum/common/Component';
import PostWarning from './PostWarning';
import WarningPreview from './WarningPreview';
export default class PostWarningList extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.post = this.attrs.post;
  }
  view() {
    return m("div", {
      className: "Post-warning-list"
    }, this.attrs.post.warnings().map(warning => {
      return PostWarning.component({
        warning
      });
    }));
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/components/PostWarningList', PostWarningList);